<template>
  <v-row class="pt-4">
    <v-col cols="12" xs="12" class="pt-0 py-0">
      <span class="headline">Kanäle zuweisen bzw. entfernen</span>
    </v-col>
    <v-col cols="12" xs="12">
      <v-tabs
          v-model="tab"
          background-color="#EEEEEE"
          color="black"
      >
        <v-tab>Kanäle</v-tab>
        <v-tab>Netzwerke</v-tab>
        <v-tab>Standorte</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <TableChannels ref="tableChannels"  v-model="selectedChannels" :removeVeranstalter="removeVeranstalter" :showTitle="false" :isCompanyView="true"/>
        </v-tab-item>
        <v-tab-item>
          <TableSelCompanies ref="tableCompanies" v-model="selectedCompanies" :show-title="false"/>
        </v-tab-item>
        <v-tab-item>
          <TableStandorte ref="tableStandorte" v-model="selectedLocations" :showTitle="false" :isCompanyView="true" :filterArray="chash" :hideAktions="true"/>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
    <v-col cols="12" xs="12" align="end" class="text-right pt-0 mt-0" v-if="(selectedChannels && selectedCompanies && selectedLocations) && (selectedChannels.length > 0 && selectedCompanies.length > 0 && selectedLocations.length > 0)">
      K: {{selectedChannels.length}} /
      N: {{selectedCompanies.length}} /
      S: {{selectedLocations.length}}
      <v-btn @click="shareChannels()" class="mr-2" color="primary">zuweisen</v-btn>
      <v-btn @click="removeChannels()" color="primary">entfernen</v-btn>
    </v-col>
    <v-col cols="12" v-else>
      Bitte wählen Sie Kanal, Netzwerk und Standort aus.
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import TableStandorte from "@/components/tables/TableStandorte.vue";
import TableChannels from "@/components/tables/TableChannels.vue";
import TableSelCompanies from "@/components/tables/TableSelCompanies.vue";
import _ from "lodash";

export default {
  name: 'Uploads',
  components: {TableSelCompanies, TableChannels, TableStandorte},
  data () {
    return {
      removeVeranstalter: true,
      selectedCompanies: [],
      chash: [],
      selectedChannels: [],
      selectedLocations: [],
      tab: 0
    }
  },
  methods: {
    createItem: function () {
      console.log('createItem')
      Vue.prototype.$api.createPlaylist({}, this.onPlayListCreated)
    },
    onPlayListCreated: function (newItem) {
      console.log('onPlayListCreated', newItem)
      this.$router.push('/Playlist/' + newItem.guid)
    },
    shareChannels: function () {
      console.log('shareChannels')
      const cmp = this
      _.forEach(cmp.selectedChannels, function (pl) {
        _.forEach(cmp.selectedLocations, function (loc) {
          Vue.prototype.$api.createCloneLinkPlayListToCompany(pl, loc, function (data) {
            console.log('link done', data)
          })
        })
      })
    },
    removeChannels: function () {
      console.log('removeChannels')
      const cmp = this
      _.forEach(cmp.selectedChannels, function (pl) {
        _.forEach(cmp.selectedLocations, function (loc) {
          Vue.prototype.$api.removeCloneLinkPlayListToCompany(pl.guid, loc.guid, function (data) {
            console.log('unlink done', data)
          })
        })
      })
    }
  },
  watch: {
    selectedCompanies: function() {

      let chash = []
      for (let i=0;i< this.selectedCompanies.length;i++) {
        const c = this.selectedCompanies[i]
        chash.push(c.guid)
      }
      this.chash = chash

      this.$refs.tableStandorte.reload()
    }
  },
  mounted () {
    //Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>
